import { render, staticRenderFns } from "./NotFoundLayout.vue?vue&type=template&id=5add4e24&scoped=true&functional=true&"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js&"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundLayout.vue?vue&type=style&index=0&id=5add4e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5add4e24",
  null
  
)

export default component.exports